import script from "./HigherEducationRecordTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HigherEducationRecordTable.vue?vue&type=script&setup=true&lang=js"

import "./HigherEducationRecordTable.vue?vue&type=style&index=0&id=22593f9d&scoped=true&lang=scss"
script.__scopeId = "data-v-22593f9d"

export default script